module.exports = __webpack_public_path__ + "img/1639.29d8a585.png";